import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { ConfirmationService, MessageService} from 'primeng';
import { ToastService } from 'src/app/core/toast.service';
import { UnidadeApiService } from 'src/app/dao/api_unidade.service';
import { GlobalService } from 'src/app/dao/global.service';
import { Unidade } from 'src/app/model/unidade';

@Component({
  selector: 'app-encomenda',
  templateUrl: './encomenda.page.html',
  styleUrls: ['./encomenda.page.scss'],
  providers: [MessageService, ConfirmationService]
})
export class EncomendaPage implements OnInit {

  unidade: Unidade;
  plano;
  dominio;
  loja;

  jsonEncomenda;
  jsonEncomendaObj;

  deAte;
  diaSemana;
  textoInformativo;


  exibirDia0 = false;
  exibirDia1 = false;
  exibirDia2 = false;
  exibirDia3 = false;
  exibirDia4 = false;
  exibirDia5 = false;
  exibirDia6 = false;
  exibirDiaTodos = false;
  novosDiasExibir;
  disableVar = false;



  intervalos: string[] = ['manhã', 'tarde', 'noite', 'madrugada'];
  selectedIntervalos: string[] = [];
  intervaloDialog: boolean = false;
  novoIntervalo: string = '';
  submitted: boolean = false;

  diaDe;
  diaAte;
  labelEncomenda;

  constructor(public alertController: AlertController, public global: GlobalService, private route: ActivatedRoute, private toast: ToastService, private apiUnidade: UnidadeApiService, private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.labelEncomenda = this.global.labelEncomenda
    this.unidade = new Unidade();
    // tslint:disable-next-line: radix
    this.loadUnidade();
    //this.montaOpcaodias();
    this.dominio = this.global.dominio;
    this.loja = this.global.loja;

    this.plano = this.global.plano;

  }

  delay(ms: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  }

    // Método para abrir o diálogo de adicionar intervalo
    openNew(): void {
      this.novoIntervalo = '';
      this.submitted = false;
      this.intervaloDialog = true;
    }
  
    // Método para ocultar o diálogo de adicionar intervalo
    hideDialog(): void {
      this.intervaloDialog = false;
    }
  
    // Método para adicionar um novo intervalo
    addIntervalo(): void {
      this.submitted = true;
      if (this.novoIntervalo) {
        this.intervalos.push(this.novoIntervalo);
        this.novoIntervalo = '';
        this.intervaloDialog = false;
      }
    }
  
    // Método para excluir um intervalo
    deleteIntervalo(intervalo: string): void {
      if(this.intervalos.length > 1){
      const index = this.intervalos.indexOf(intervalo);
      if (index !== -1) {
        this.intervalos.splice(index, 1);
      }
    }else{
      this.toast.showError("Você precisa manter ao menos 1 período!");
    }
    }



  async loadUnidade() {
    this.unidade = await this.apiUnidade.getAtual();


    if (this.unidade.conf_encomenda === null || this.unidade.conf_encomenda === "") {
      this.jsonEncomenda = '{"deAte":[2,10], "diaDaSemana":[0,1,2,3,4,5,6], "periodoEntrega":["manhã","tarde","noite"], "textoInformativo":"Faça aqui a encomenda do seu pedido!!!"}';
      this.jsonEncomendaObj = await JSON.parse(this.jsonEncomenda);
    } else {
      try {
        this.jsonEncomenda = this.unidade.conf_encomenda;
        this.jsonEncomendaObj = await JSON.parse(this.unidade.conf_encomenda);
      } catch (error) {
        this.jsonEncomenda = '{"deAte":[2,10], "diaDaSemana":[0,1,2,3,4,5,6], "periodoEntrega":["manhã","tarde","noite"], "textoInformativo":"Faça aqui a encomenda do seu pedido!!!"}';
        this.jsonEncomendaObj = await JSON.parse(this.jsonEncomenda);
      }
    }

    
    this.deAte = this.jsonEncomendaObj.deAte;
    this.diaDe =this.deAte[0];
    this.diaAte = this.deAte[1];
    this.diaSemana = this.jsonEncomendaObj.diaDaSemana;
    this.intervalos = this.jsonEncomendaObj.periodoEntrega;
    this.textoInformativo = this.jsonEncomendaObj.textoInformativo;

    this.verificaDiasPush();
    }
  

    selecionarTodos(){
      if(this.exibirDiaTodos){
        this.exibirDia0 = true;
        this.exibirDia1 = true;
        this.exibirDia2 = true;
        this.exibirDia3 = true;
        this.exibirDia4 = true;
        this.exibirDia5 = true;
        this.exibirDia6 = true;
        this.disableVar = true;
      }else{
        this.disableVar = false;
      }
    }



    verificaDias() {
      this.novosDiasExibir = [];
  
      if (this.exibirDia0) {
        this.novosDiasExibir.push(0);
      }
      if (this.exibirDia1) {
        this.novosDiasExibir.push(1);
      }
      if (this.exibirDia2) {
        this.novosDiasExibir.push(2);
      }
      if (this.exibirDia3) {
        this.novosDiasExibir.push(3);
      }
      if (this.exibirDia4) {
        this.novosDiasExibir.push(4);
      }
      if (this.exibirDia5) {
        this.novosDiasExibir.push(5);
      }
      if (this.exibirDia6) {
        this.novosDiasExibir.push(6);
      }
      if(this.exibirDiaTodos){
        this.novosDiasExibir = [];
        this.novosDiasExibir.push(0);
        this.novosDiasExibir.push(1);
        this.novosDiasExibir.push(2);
        this.novosDiasExibir.push(3);
        this.novosDiasExibir.push(4);
        this.novosDiasExibir.push(5);
        this.novosDiasExibir.push(6);
      }
    }
  
  
    verificaDiasPush() {

      let diasDaSemana = JSON.stringify(this.diaSemana);
      console.log(JSON.stringify(this.diaSemana));
      
      if (diasDaSemana.includes("0")) {
        this.exibirDia0 = true;
      }
      if (diasDaSemana.includes("1")) {
        this.exibirDia1 = true;
      }
      if (diasDaSemana.includes("2")) {
        this.exibirDia2 = true;
      }
      if (diasDaSemana.includes("3")) {
        this.exibirDia3 = true;
      }
      if (diasDaSemana.includes("4")) {
        this.exibirDia4 = true;
      }
      if (diasDaSemana.includes("5")) {
        this.exibirDia5 = true;
      }
      if (diasDaSemana.includes("6")) {
        this.exibirDia6 = true;
      }
      if (diasDaSemana.includes("0123456")) {
        this.exibirDiaTodos = true;
        this.disableVar = true;
      }
    }
  


  async onSubmit() {

    this.verificaDias();


    this.deAte[0] = this.diaDe;
    this.deAte[1] = this.diaAte;
    this.diaSemana = this.novosDiasExibir;

    this.jsonEncomendaObj.deAte = this.deAte;
    this.jsonEncomendaObj.diaDaSemana = this.diaSemana;
    this.jsonEncomendaObj.periodoEntrega = this.intervalos;
    this.jsonEncomendaObj.textoInformativo = this.textoInformativo;

    this.unidade.conf_encomenda = JSON.stringify(this.jsonEncomendaObj);


    if (this.unidade.label_encomenda) {
      //this.global.labelEncomenda = 'Agendamento';
      localStorage.setItem('labelEncomenda', 'Agendamento');
    } else {
      //this.global.labelEncomenda = 'Encomenda';
      localStorage.setItem('labelEncomenda', 'Encomenda');
    }

    this.apiUnidade.alterarLabelEncomenda(this.unidade.label_encomenda);


      for (var key in this.unidade) {
        if(this.unidade[key] === false){
          this.unidade[key] = 0;
        }
        if(this.unidade[key] === true){
          this.unidade[key] = 1;
        }
    }
      
      try {
        console.log(this.unidade);
        const result = await this.apiUnidade.atualizar(this.unidade);
        console.log(result);
        this.unidade.id = result.id;


        this.toast.showSucess('Salvo com sucesso');
      } catch (error) {
        console.log(error);
        this.toast.showError('Ocorreu um erro ao tentar salvar as Configurações');
      }

  }
  
}

